import { createContext, Dispatch, SetStateAction } from "react";

// Define the shape of a single chat message
interface ChatMessage {
  text: string;
  isBot: boolean;
  chartImage?: string;
  questionCategory?: string;
  embeddedQuestion?: string;
}

// Define the shape of the context value
export interface AppContextType {
  chatMessages: ChatMessage[];
  setChatMessages: Dispatch<SetStateAction<ChatMessage[]>>;
  chatHistory: any[];
  setChatHistory: Dispatch<SetStateAction<any[]>>;
  // --- NEW: Add state for submitted feedback ---
  submittedFeedback: number[];
  setSubmittedFeedback: Dispatch<SetStateAction<number[]>>;
  user: any;
  setUser: (user: any) => void;
  surveyResult: any[];
  setSurveyResult: (result: any[]) => void;
  // Landing mode state: true = initial home view, false = app bar revealed
  isLandingMode: boolean;
  setIsLandingMode: Dispatch<SetStateAction<boolean>>;
  // Track if menu bar animation has completed
  menuBarAnimationComplete: boolean;
}

// Create the context with a default value
const AppContext = createContext<AppContextType | null>(null);

export default AppContext;